import { render, staticRenderFns } from "./destabilize.vue?vue&type=template&id=7164b704&scoped=true&"
import script from "./destabilize.vue?vue&type=script&lang=js&"
export * from "./destabilize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164b704",
  null
  
)

export default component.exports